"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 0.0.2
 */
var fc = require("fast-check");
var Either_1 = require("fp-ts/lib/Either");
/**
 * Returns an `Arbitrary` that yelds only `right`s
 *
 * @since 0.0.2
 */
function getRight(arb) {
    return arb.map(function (a) { return Either_1.right(a); });
}
exports.getRight = getRight;
/**
 * Returns an `Arbitrary` that yelds only `left`s
 *
 * @since 0.0.2
 */
function getLeft(arb) {
    return arb.map(function (l) { return Either_1.left(l); });
}
exports.getLeft = getLeft;
/**
 * Returns an `Arbitrary` that yelds both `left`s and `right`s
 *
 * @since 0.0.2
 */
function getEither(leftArb, rightArb) {
    return fc.oneof(getLeft(leftArb), getRight(rightArb));
}
exports.getEither = getEither;
